module.exports = __webpack_public_path__ + "img/fail5.3a7c490f.gif";